module.exports = __webpack_public_path__ + "img/1125-joy-normal.97bd5fe4.png";